<div class="sk-page" *ngIf="!loading && customer">

  <!-- Hero-Kopf mit den wichtigsten Aktionen -->
  <div class="sk-hero">
    <button mat-icon-button class="sk-back" (click)="back()" aria-label="Zurück zur Übersicht">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="sk-hero-avatar">
      <img *ngIf="customer.logoPath" [src]="getLogoUrl(customer.logoPath)" alt="Logo">
      <ng-container *ngIf="!customer.logoPath">{{customer.name.charAt(0).toUpperCase()}}</ng-container>
    </div>

    <div class="sk-hero-info">
      <h1>
        {{customer.name}}
        <span class="sk-badge"><mat-icon class="sk-inline-icon">badge</mat-icon> Stammkunde</span>
      </h1>
      <div class="sk-hero-sub">
        <span *ngIf="customer.address"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{customer.address}}</span>
        <span *ngIf="customer.contactPersonName"><mat-icon class="sk-inline-icon">person</mat-icon>{{customer.contactPersonName}}</span>
        <span *ngIf="customer.contactPersonPhone"><mat-icon class="sk-inline-icon">phone</mat-icon>{{customer.contactPersonPhone}}</span>
      </div>
    </div>

    <span class="sk-hero-spacer"></span>

    <div class="sk-hero-actions">
      <button mat-raised-button class="sk-btn-light" (click)="openPlanung()">
        <mat-icon>calendar_view_week</mat-icon> Planungsboard
      </button>
      <button mat-stroked-button class="sk-btn-ghost" *ngIf="canManage" (click)="openAuftragForm()">
        <mat-icon>add</mat-icon> Neuer Auftrag
      </button>
      <button mat-icon-button class="sk-back" [matMenuTriggerFor]="heroMenu" aria-label="Weitere Aktionen">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #heroMenu="matMenu">
        <button mat-menu-item *ngIf="canManage" (click)="editCustomer()">
          <mat-icon>edit</mat-icon> Stammdaten bearbeiten
        </button>
        <button mat-menu-item (click)="openWartungDetail()">
          <mat-icon>open_in_new</mat-icon> Vollständige Kundenansicht
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Kennzahlen (klickbar: springt zum passenden Reiter) -->
  <div class="sk-stats">
    <button class="sk-stat" (click)="goTab(tabAuftraege)">
      <span class="sk-stat-icon"><mat-icon>assignment</mat-icon></span>
      <span>
        <span class="sk-stat-value">{{offeneAuftraege}}</span>
        <span class="sk-stat-label">Offene Aufträge</span>
      </span>
    </button>
    <button class="sk-stat" (click)="openPlanung()">
      <span class="sk-stat-icon tone-orange"><mat-icon>event_available</mat-icon></span>
      <span>
        <span class="sk-stat-value">{{gesamtEinsaetze}}</span>
        <span class="sk-stat-label">Einsätze geplant</span>
      </span>
    </button>
    <button class="sk-stat" (click)="goTab(tabTeam)">
      <span class="sk-stat-icon tone-green"><mat-icon>groups</mat-icon></span>
      <span>
        <span class="sk-stat-value">{{teamGroesse}}</span>
        <span class="sk-stat-label">Team &amp; Arbeiter</span>
      </span>
    </button>
    <button class="sk-stat" (click)="goTab(tabLager)">
      <span class="sk-stat-icon tone-brown"><mat-icon>inventory_2</mat-icon></span>
      <span>
        <span class="sk-stat-value">{{linkedWarehouses.length}}</span>
        <span class="sk-stat-label">Verknüpfte Lager</span>
      </span>
    </button>
  </div>

  <mat-tab-group animationDuration="150ms" [(selectedIndex)]="selectedTab">

    <!-- ── Übersicht (nur Bauleiter/Admin) ── -->
    <mat-tab *ngIf="hasOverviewTab">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">insights</mat-icon> Übersicht
      </ng-template>
      <div class="tab-content">
        <app-bauleiter-uebersicht [embedded]="true" [fixedCustomerId]="customerId"></app-bauleiter-uebersicht>
      </div>
    </mat-tab>

    <!-- ── Aufträge ── -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon> Aufträge
      </ng-template>

      <div class="tab-content">
        <div class="sk-section-head">
          <div class="sk-filter-chips">
            <button class="sk-filter-chip" [class.active]="auftragFilter === 'alle'"
                    (click)="auftragFilter = 'alle'">Alle ({{countFor('alle')}})</button>
            <button class="sk-filter-chip" [class.active]="auftragFilter === 'offen'"
                    (click)="auftragFilter = 'offen'">Offen ({{countFor('offen')}})</button>
            <button class="sk-filter-chip" [class.active]="auftragFilter === 'fertig'"
                    (click)="auftragFilter = 'fertig'">Abgeschlossen ({{countFor('fertig')}})</button>
          </div>
          <span class="sk-spacer"></span>
          <button mat-raised-button color="primary" *ngIf="canManage" (click)="openAuftragForm()">
            <mat-icon>add</mat-icon> Neuer Auftrag
          </button>
        </div>

        <div class="sk-empty" *ngIf="filteredAuftraege.length === 0">
          <div class="sk-empty-icon"><mat-icon>assignment</mat-icon></div>
          <p *ngIf="auftraege.length === 0">Noch keine Aufträge.<br>
            <span class="sk-muted">Lege den ersten Auftrag an – danach planst du die Einsätze per Drag &amp; Drop im Planungsboard.</span>
          </p>
          <p *ngIf="auftraege.length > 0">Keine Aufträge in dieser Ansicht.</p>
          <button mat-raised-button color="primary" *ngIf="canManage && auftraege.length === 0" (click)="openAuftragForm()">
            <mat-icon>add</mat-icon> Ersten Auftrag anlegen
          </button>
        </div>

        <div class="sk-card sk-card-hover auftrag-card" *ngFor="let a of filteredAuftraege"
             [attr.data-status]="a.status" (click)="openAuftrag(a)">
          <div class="auftrag-row">
            <div class="auftrag-main">
              <div class="auftrag-title-row">
                <h3>{{a.title}}</h3>
                <span class="status-chip" [attr.data-status]="a.status">{{statusLabel(a.status)}}</span>
              </div>
              <div class="auftrag-meta">
                <span *ngIf="a.orderNumber"><mat-icon class="sk-inline-icon">tag</mat-icon>{{a.orderNumber}}</span>
                <span *ngIf="a.location"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{a.location}}</span>
                <span *ngIf="a.dueDate"><mat-icon class="sk-inline-icon">event</mat-icon>Fällig: {{a.dueDate | date:'dd.MM.yyyy'}}</span>
                <span><mat-icon class="sk-inline-icon">groups</mat-icon>{{a.assignmentCount}} {{a.assignmentCount === 1 ? 'Einsatz' : 'Einsätze'}}</span>
                <span *ngIf="a.primaryWarehouseName"><mat-icon class="sk-inline-icon">inventory_2</mat-icon>{{a.primaryWarehouseName}}</span>
              </div>
            </div>
            <div class="auftrag-actions" *ngIf="canManage">
              <button mat-icon-button (click)="editAuftrag(a, $event)" matTooltip="Bearbeiten">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="deleteAuftrag(a, $event)" matTooltip="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
            <mat-icon class="chevron">chevron_right</mat-icon>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- ── Team ── -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">groups</mat-icon> Team ({{teamGroesse}})
      </ng-template>

      <div class="tab-content">
        <!-- Login-Team -->
        <div class="sk-section-head">
          <h2><mat-icon>engineering</mat-icon> Team-Mitglieder</h2>
          <span class="sk-spacer"></span>
          <button mat-raised-button color="primary" *ngIf="isSuperAdmin" (click)="openTeamDialog()">
            <mat-icon>edit</mat-icon> Team bearbeiten
          </button>
        </div>

        <div class="sk-empty" *ngIf="members.length === 0">
          <div class="sk-empty-icon"><mat-icon>groups</mat-icon></div>
          <p>Noch kein Team zugewiesen.<br>
            <span class="sk-muted">Bauleiter planen Aufträge und Einsätze, Vorarbeiter sehen ihre zugeteilten Aufgaben.</span>
          </p>
          <button mat-raised-button color="primary" *ngIf="isSuperAdmin" (click)="openTeamDialog()">
            <mat-icon>person_add</mat-icon> Team zuweisen
          </button>
        </div>

        <div class="member-grid">
          <div class="sk-card member-card" *ngFor="let m of members">
            <mat-icon class="member-icon" [class.role-bauleiter]="m.role === 'Bauleiter'">
              {{m.role === 'Bauleiter' ? 'engineering' : 'construction'}}
            </mat-icon>
            <div class="member-info">
              <strong>{{m.userName || m.userId}}</strong>
              <span class="member-email" *ngIf="m.email">{{m.email}}</span>
            </div>
            <span class="role-chip" [attr.data-role]="m.role">{{m.role}}</span>
          </div>
        </div>

        <!-- Arbeiter ohne Login -->
        <div class="sk-section-head worker-head">
          <h2><mat-icon>construction</mat-icon> Arbeiter (ohne Login)</h2>
          <span class="sk-spacer"></span>
          <button mat-stroked-button *ngIf="canManage" (click)="openWorkerDialog()">
            <mat-icon>person_add</mat-icon> Arbeiter anlegen
          </button>
        </div>
        <p class="sk-muted worker-hint">
          Arbeiter haben keinen App-Zugang – sie werden bei der Einsatzplanung zugeteilt,
          nur zur Information, wer wo eingesetzt war.
        </p>

        <div class="sk-empty" *ngIf="workers.length === 0">
          <div class="sk-empty-icon"><mat-icon>construction</mat-icon></div>
          <p>Noch keine Arbeiter angelegt.</p>
          <button mat-raised-button color="primary" *ngIf="canManage" (click)="openWorkerDialog()">
            <mat-icon>person_add</mat-icon> Ersten Arbeiter anlegen
          </button>
        </div>

        <div class="member-grid">
          <div class="sk-card member-card" [class.sk-card-hover]="canManage"
               *ngFor="let w of workers" (click)="canManage && openWorkerDialog(w)">
            <mat-icon class="member-icon worker-icon">construction</mat-icon>
            <div class="member-info">
              <strong>{{w.name}}</strong>
              <span class="member-email" *ngIf="w.phone">{{w.phone}}</span>
            </div>
            <span class="role-chip" data-role="Arbeiter">Arbeiter</span>
            <button mat-icon-button *ngIf="canManage" (click)="deleteWorker(w, $event)" matTooltip="Entfernen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- ── Lager ── -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">inventory_2</mat-icon> Lager ({{linkedWarehouses.length}})
      </ng-template>

      <div class="tab-content">
        <div class="sk-section-head">
          <h2><mat-icon>inventory_2</mat-icon> Verknüpfte Lager</h2>
          <span class="sk-spacer"></span>
          <button mat-raised-button color="primary" *ngIf="canManage" (click)="openLagerDialog()">
            <mat-icon>add_link</mat-icon> Lager verknüpfen
          </button>
        </div>

        <div class="sk-empty" *ngIf="linkedWarehouses.length === 0">
          <div class="sk-empty-icon"><mat-icon>inventory_2</mat-icon></div>
          <p>Noch kein Lager verknüpft.<br>
            <span class="sk-muted">Verknüpfte Lager sehen Bauleiter und Vorarbeiter dieses Stammkunden automatisch mit.</span>
          </p>
          <button mat-raised-button color="primary" *ngIf="canManage" (click)="openLagerDialog()">
            <mat-icon>add_link</mat-icon> Lager verknüpfen
          </button>
        </div>

        <div class="member-grid">
          <div class="sk-card member-card" *ngFor="let w of linkedWarehouses">
            <mat-icon class="member-icon warehouse-icon">warehouse</mat-icon>
            <div class="member-info"><strong>{{w.name}}</strong></div>
            <button mat-icon-button *ngIf="canManage" (click)="unlinkWarehouse(w)" matTooltip="Verknüpfung lösen">
              <mat-icon>link_off</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- ── Stammdaten ── -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">business</mat-icon> Stammdaten
      </ng-template>

      <div class="tab-content">
        <div class="sk-section-head">
          <h2><mat-icon>business</mat-icon> Stammdaten</h2>
          <span class="sk-spacer"></span>
          <button mat-raised-button color="primary" *ngIf="canManage" (click)="editCustomer()">
            <mat-icon>edit</mat-icon> Bearbeiten
          </button>
          <button mat-stroked-button (click)="openWartungDetail()">
            <mat-icon>open_in_new</mat-icon> Vollständige Kundenansicht
          </button>
        </div>

        <div class="sk-card stammdaten-card">
          <div class="daten-grid">
            <div class="daten-item" *ngIf="customer.contactPersonName">
              <label>Ansprechpartner</label>
              <span>{{customer.contactPersonName}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.contactPersonPhone">
              <label>Telefon</label>
              <span>{{customer.contactPersonPhone}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.contactPersonEmail">
              <label>E-Mail</label>
              <span>{{customer.contactPersonEmail}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.customerNumber">
              <label>Kundennummer</label>
              <span>{{customer.customerNumber}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.projectNumber">
              <label>Projektnummer</label>
              <span>{{customer.projectNumber}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.invoiceAddress">
              <label>Rechnungsadresse</label>
              <span>{{customer.invoiceAddress}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.paymentTerms">
              <label>Zahlungsbedingungen</label>
              <span>{{customer.paymentTerms}}</span>
            </div>
            <div class="daten-item" *ngIf="customer.vatId">
              <label>UID</label>
              <span>{{customer.vatId}}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div class="sk-loading" *ngIf="loading">
  <mat-spinner diameter="42"></mat-spinner>
</div>
